import React, { useEffect, useMemo, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { httpRequest } from '../../../httpRequest';
import CaseTable from '../../ActivityCenter/SubComponents/CaseTable';
import { getSessionStorageItem, setSessionStorageItemWithExpiration, ADVISOR_CASES_STATUS_HIGH_LEVEL_KEY, ADVISOR_OBJECT_KEY, SESSION_STORAGE_ACCOUNT_KEY, ADVISOR_ACTIVITY_CENTER_KEY } from '../../../sessionStorage';
import { ValidateUserEntitlements } from '../../Common/ValidateUserEntitlements';

export default function CaseTableHighLevelView(props) {

  const { openCaseDetail } = props;

  let advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  let role = advisorObj && advisorObj.role;
  let faList = advisorObj && advisorObj.faOptions;

  const defaultState = {
    cases: {},
    pageLoading: true,
    casesLoading: null,
    pageNumber: 1,
    casesPerPage: 5,
    updateCaseTable: false,
    statusCategories: ['Quoting Coverage', 'Completing Application', 'Application Review', 'Policy Delivery', 'Coverage Active', 'Closed']
  };

  const [activityCenterState, updateActivityCenterState] = useState(defaultState);
  const firstFaOption = advisorObj && advisorObj.faOptions && advisorObj.faOptions[0] && advisorObj.faOptions[0].id && advisorObj.faOptions[0].id.split('-');
  const officeNumber = firstFaOption && firstFaOption.length === 2 ? firstFaOption[0] : "";
  const faNumber = firstFaOption && firstFaOption.length === 2 ? firstFaOption[1] : "";
  const isValidateUserEntitlement = useMemo(() => ValidateUserEntitlements(faList, role, officeNumber, faNumber), [officeNumber, faNumber]);

  useEffect(() => {

    const casesFromSession = getSessionStorageItem(ADVISOR_CASES_STATUS_HIGH_LEVEL_KEY);

    let requiredToFetchCaseInfo = ((casesFromSession === null || casesFromSession || activityCenterState.updateCaseTable) && isValidateUserEntitlement);

    if (requiredToFetchCaseInfo) {

      updateActivityCenterState({ ...activityCenterState, casesLoading: true, pageLoading: true });

      const baseAddress = process.env.REACT_APP_COVR_SERVICES_URL;

      const queryParams = {
        officeNumber,
        faNumber,
        branchNumber: "",
        accountNumber: "",
        caseStatusCategory: "",
        illustrationStatusCategory: "",
        firstOrBusinessName: "",
        lastName: "",
        faFirstName: "",
        faLastName: "",
        referenceID: "",
        ticketNumber: "",
        policyNumber: "",
        status: "",
        state: "",
        deathBenefitMinimum: null,
        deathBenefitMaximum: null,
        premiumAmountMinimum: null,
        premiumAmountMaximum: null,
        carrierName: "",
        planName: "",
        createdDateStart: "",
        createdDateEnd: "",
        pageNumber: activityCenterState.pageNumber,
        itemsPerPage: activityCenterState.casesPerPage,
        quoteType: "",
        isReplacement: null,
        isReg6null:null,
        isESign: null,
        isIllustration: null,
        externalUserID: null,
        defaultView: true
    };
    httpRequest.post(`${baseAddress}/api/MorganStanley/GetCases`, queryParams ).then((data) => {
      if(data.success && data.content.length > 0){
        setSessionStorageItemWithExpiration(ADVISOR_CASES_STATUS_HIGH_LEVEL_KEY, data.content[0], 60);

        updateActivityCenterState({
          ...activityCenterState,
          cases: data.content[0],
          casesLoading: false,
          pageLoading: false,
          updateCaseTable: false
        });
      } else {
        updateActivityCenterState({
          ...activityCenterState,
          cases: {},
          casesLoading: false,
          pageLoading: false,
          updateCaseTable: false
        });
      }
      }).catch(() => {
        updateActivityCenterState({
          ...activityCenterState,
          cases: {},
          casesLoading: false,
          pageLoading: false,
          updateCaseTable: false
        });
      });

    } else {
      if (!isValidateUserEntitlement) {
        sessionStorage.removeItem(ADVISOR_ACTIVITY_CENTER_KEY);
      }
      updateActivityCenterState({ 
        ...activityCenterState, 
        cases: isValidateUserEntitlement ? (casesFromSession || {}) : {}, 
        casesLoading: false, 
        pageLoading: false, 
        updateCaseTable: false
      });
    }
  }, [activityCenterState.updateCaseTable]);

  return (
    <CaseTableOverview
      stateUpdate={updateActivityCenterState}
      state={activityCenterState}
      openCaseDetail={openCaseDetail}
    />
  )

}

function CaseTableOverview(props) {

  const { openCaseDetail, state, stateUpdate } = props;

  if (!state.cases) {
    return <div className="d-flex justify-content-center p-5"><CircularProgress /></div>;
  }

  return <CaseTable
    state={state}
    openCaseDetail={openCaseDetail}
    stateUpdate={stateUpdate}
    homePage={true}
  />;
}




// WEBPACK FOOTER //
// ./src/components/Home/SubComponents/CaseStatusHighLevelView.js